<template>
    <div class="tab-content d-flex tab-default tab-sm text-dark">
        <div class="bg-white" style="width:50%">
            <div class="clearfix">
            <Track
                :indent="orderDetails"
                :simTrackingEnabled="simTrackingEnabled"
                :isSimTrackingAllowed="isSimTrackingAllowed"
                :gpsTrackingEnabled="gpsTrackingEnabled"
                :yetToTruckIn="yetToTruckIn"
                :hasDriverAccepted="hasDriverAccepted"
                :appTrackingEnabled="appTrackingEnabled"
                :hyperTrackingEnabled="hyperTrackingEnabled"
                :trackingAfterTruckOut="trackingAfterTruckOut"
                :mapConfig="mapConfig"
                @closeDrawer="closeDrawer" />
            </div>

            <Depot v-if="baseFreightCharge" :order="orderDetails" :configurations="configurations" :baseFreightCharge="baseFreightCharge" />
            <Collapse v-model="activeName" accordion class="collapse-slider">
                <CollapseItem title="Other Information" name="0"
                v-if="showPurchaseOrderDetails || $hasFeature('weigh_bridge') ||
                hasCustomFields">
                <div class="flex-container panel-head align-top mb-15"
                    v-if="showPurchaseOrderDetails" >
                    <div class="flex-item floating">
                        <p v-bind:class="{'f-right text-right': ind%2}"
                        v-for="(item, ind) in purchaseOrderFields" v-bind:key="ind">
                        {{item.label}} :
                        <strong>{{orderDetails.purchase_order_details[item.name]}}</strong>
                        </p>
                    </div>
                </div>
                <WeighInWeightOut
                    v-if="$hasFeature('weigh_bridge') && orderDetails"
                    :showActions="true"
                    :orderDetails="orderDetails"
                    :hideEdit="!showEditWeighBridge" />
                    <CustomField v-if="hasCustomFields"
                    :currentIndent="orderDetails"
                    :indentCustomFields="indentCustomFields"
                    :indentSourceCustomFields="indentSourceCustomFields"
                    :indentDestinationCustomFields="indentDestinationCustomFields"
                    :customFields="orderDetails.custom_fields" />
                </CollapseItem>
                <CollapseItem v-if="!isPackingIndentEnabled"
                    v-for="(source, index) in orderDetails.sources"
                    v-bind:key="source.unique_id"
                    :title="sourceHasGate(source.gate_id,source.location_id, source)"
                    :name="index">
                    <div class="flex-container panel-head align-top">
                    <div class="flex-item">
                        <p>
                        {{$t('INDENT_REFERENCE_ID')}} :
                        <strong>{{sourceHasGateRefrenceId(source.gate_id,source.location_id, source)}}</strong>
                        </p>
                        <p v-if="!hasDocks">
                        {{$t('INDENT_LOADERS')}} :
                        <strong>{{ source.loader_available ? $t('INDENT_YES') : $t('INDENT_NO')}}</strong>
                        </p>
                    </div>
                    <div class="flex-item text-right">
                        <p>
                        {{$t('INDENT_VEHICLE_REQUIREMENT_DATE')}} :
                        <strong>{{source.loading_date | moment("DD MMM YYYY")}}</strong>
                        </p>
                        <p v-if="!hasDocks">
                        {{$t('INDENT_PAID_BY')}} :
                        <strong>{{ source.add_to_invoice ? $t('INDENT_YES') : $t('INDENT_NO')}}</strong>
                        </p>
                    </div>
                    </div>
                    <Table
                    :data="source.gate_id ? getGateDestinations(source) : getSourceDestinations(source)"
                    :stripe="true"
                    align="top"
                    class="table-striped bordered my-15"
                    max-height="250px" >
                    <TableColumn :label="$t('INDENT_SHIPPED_TO')" width="210">
                        <template slot-scope="scope">
                        <span v-if="!scope.row.consignmentNumber">
                            <span class="d-block">{{scope.row.shipped_to}}</span>
                            <Ellipsis class="text-xs" :text="getShippedToRefIdWithCity(scope.row)" :length="25" />
                        </span>

                        <span v-if="scope.row.consignmentNumber">
                            <span class="d-block">{{scope.row.shipped_to}}</span>
                            <Tooltip :open-delay="200" effect="dark" placement="bottom">
                            <span class="pointer">
                                <Ellipsis class="text-xs" :text="getShippedToRefIdWithCity(scope.row)" :length="25" />
                            </span>
                            <div slot="content">
                                {{$t('INDENT_CONSIGNMENT_NUMBER')}} :{{scope.row.consignmentNumber}}
                            </div>
                            </Tooltip>
                        </span>
                        </template>
                    </TableColumn>
                    <TableColumn :label="$t('INDENT_SOLD_TO')" width="210">
                        <template slot-scope="scope">
                        <span class="d-block">{{scope.row.sold_to}}</span>
                        <Ellipsis class="text-xs" :text="getSoldToRefIdWithCity(scope.row)" :length="25" />
                        </template>
                    </TableColumn>
                    <TableColumn prop="expected_date" :label="$t('INDENT_EXPECTED_DATE')" width="140">
                    </TableColumn>
                    <TableColumn prop="unloaders" :label="$t('INDENT_UNLOADERS')" width="100">
                    </TableColumn>
                    <TableColumn prop="paid_by" :label="$t('INDENT_PAID_BY')">
                    </TableColumn>
                    </Table>
                </CollapseItem>
            </Collapse>
        </div>
        <div class="pl-20" style="width:50%">
        <div class="timeline-multi timeline-right-default">
            <Timeline :order="orderDetails"
            :integrationTimeLine="integrationTimeLine"
            :hideGateDetails="isReturnVendor"
            :timeFormat="timeFormat" />
        </div>
        </div>
    </div>
</template>

<script>
import { mapGetters } from 'vuex';
import { movementType as movementListType } from 'pando-constants';
import TableCell from '@/components/orders/documentation/TableCell';
import Timeline from '@/components/orders/Timeline';
import Depot from '@/components/orders/Depot';
import WeighInWeightOut from '@/components/orders/WeightInWeighOut';
import Track from '@/components/orders/actions-v2/Track';
import CustomField from '@common/components/CustomField';

export default {
  components: {
    TableCell,
    Timeline,
    Depot,
    WeighInWeightOut,
    CustomField,
    Track,
  },
  data() {
    return {
      movementListType,
      legalEntityDetails: {},
      activeName: 0,
      types: { DEPOT: 1, CONSIGNEE: 2, VENDOR_DEPOT: 3 },
      baseFreightCharge: null,
    };
  },
  props: {
    orderDetails: {
      required: true,
      default: () => ({}),
    },
    configurations: {
      required: true,
      default: () => ({}),
    },
  },
  async mounted() {
    this.getBaseFreightCharges();
  },
  computed: {
    ...mapGetters({
      integrationTimeLine: 'order/integrationTimeLine',
      indentCustomFields: 'indentV2/indentCustomFields',
      indentSourceCustomFields: 'indentV2/indentSourceCustomFields',
      indentDestinationCustomFields: 'indentV2/indentDestinationCustomFields',
      purchaseOrderFields: 'indentV2/purchaseOrderFields',
      purchaseOrderConfig: 'indentV2/purchaseOrderConfig',
      trackingList: 'order/trackingList',
    }),
    hasCustomFields() {
      return (this.indentCustomFields && this.indentCustomFields.length) ||
          (this.indentSourceCustomFields && this.indentSourceCustomFields.length) ||
          (this.indentDestinationCustomFields && this.indentDestinationCustomFields.length);
    },
    isReturnVendor() {
      return this.orderDetails && this.orderDetails.movement === this.movementListType.INWARD;
    },
    timeFormat() {
      return (this.configurations && this.configurations.is_datepicker_24H_enabled) ? 'HH:mm' : 'hh:mm A';
    },
    getMovement() {
      if (this.orderDetails) {
        if (this.orderDetails.movement === this.movementListType.RETURNS) {
          return 'Return';
        } else if (this.orderDetails.movement === this.movementListType.INWARD) {
          return 'Vendor';
        } else if (this.orderDetails.movement === this.movementListType.PRIMARY) {
          return 'Primary';
        }
        return 'Secondary';
      }
      return null;
    },
    /* start of track tab related methods */
    isSimTrackingAllowed() {
      const movement = this.getMovement.toLowerCase();
      return (this.configurations && this.configurations.track_settings &&
          this.configurations.track_settings[movement] &&
          this.configurations.track_settings[movement].enable_sim_tracking) || false;
    },
    gpsTrackingEnabled() {
      return Boolean(this.orderDetails && this.orderDetails.flow &&
          this.orderDetails.flow.gps_tracking &&
          this.orderDetails.flow.gps_tracking.is_enabled);
    },
    simTrackingEnabled() {
      return Boolean(this.orderDetails && this.orderDetails.flow &&
        this.orderDetails.flow.sim_tracking &&
          this.orderDetails.flow.sim_tracking.is_enabled);
    },
    yetToTruckIn() {
      return Boolean(this.orderDetails && this.orderDetails.sources &&
          this.orderDetails.sources.every(source => source.arrived_at === null));
    },
    trackingAfterTruckOut() {
      return Boolean(this.configurations && this.configurations.track_settings
          && this.configurations.track_settings.trip_creation_event === 'TRUCK_OUT');
    },
    hasDriverAccepted() {
      return Boolean(this.orderDetails && this.orderDetails.flow &&
        this.orderDetails.flow.driver_accepted);
    },
    hyperTrackingEnabled() {
      return !!(this.orderDetails.flow && this.orderDetails.flow.app_tracking &&
          this.orderDetails.flow.app_tracking.embed_url);
    },
    appTrackingEnabled() {
      return !!(this.orderDetails.flow && this.orderDetails.flow.app_tracking &&
          this.orderDetails.flow.app_tracking.track_trip_id);
    },
    trackTabTitle() {
      if (!this.yetToTruckIn && !this.simTrackingEnabled && this.hasDriverAccepted &&
        this.hyperTrackingEnabled) {
        return 'APP TRACK';
      }
      if (this.gpsTrackingEnabled || (this.isSimTrackingAllowed && this.simTrackingEnabled)
          || (this.appTrackingEnabled && this.hasDriverAccepted && !this.hyperTrackingEnabled)) {
        return 'TRACK';
      }
      return null;
    },
    mapConfig() {
      return (this.configurations && this.configurations.map_configuration);
    },
    /* end of track tab related methods */
    /* start of details tab methods */
    showEditWeighBridge() {
      return this.$hasFeature('weigh_bridge') && this.orderDetails &&
          this.$statusUtil.getStatusIds(['truck_arrived', 'loading_started', 'loading_ended']).includes(this.orderDetails.status) &&
          this.$hasPermission('update_weigh_bridge');
    },
    showPurchaseOrderDetails() {
      return this.orderDetails.purchase_order_details &&
          this.orderDetails.purchase_order_details.po_id && this.purchaseOrderConfig;
    },
    isPackingIndentEnabled() {
      return this.$hasFeature('packing_indent');
    },
    hasDocks() {
      return this.$hasFeature('docks');
    },
    /* end of details tab methods */
  },
  methods: {
    constructDestination(consignee) {
      const gateId = consignee.gate_id;
      const consignmentBooking = this.trackingList.length ? this.trackingList.find(
        consigneeTrack => gateId === consigneeTrack.consignee_id
            || consignee.location_id === consigneeTrack.consignee_id) : '';
      const soldDetails = (consignee.type === this.types.DEPOT) ? this.$depot.otherGate(consignee.sold_to_id, consignee.location_id) : consignee.sold_details;
      const result = {
        ref_id: (consignee.type === this.types.DEPOT) ? this.$depot.otherGate(consignee.gate_id, consignee.location_id).reference_id : consignee.details.reference_id,
        shipped_to: consignee.details.name,
        sold_to_ref_id: soldDetails && soldDetails.reference_id,
        sold_to: (consignee.type === this.types.DEPOT) ? consignee.details.name : soldDetails.name,
        unloaders: consignee.unloader_available ? 'Yes' : 'No',
        paid_by: consignee.add_to_invoice ? 'Yes' : 'No',
        expected_date: consignee.expected_delivery ?
          this.$moment(consignee.expected_delivery).format(
            'DD MMM YYYY',
          ) : '-',
        consignmentNumber: consignmentBooking
           && consignmentBooking.tracking_data && consignmentBooking.tracking_data[0]
           && consignmentBooking.tracking_data[0].tracking_id,
        sold_to_city: soldDetails && soldDetails.city,
        shipped_to_city: (consignee.type === this.types.DEPOT) ? this.$depot.otherGate(consignee.gate_id, consignee.location_id).city : consignee.details.city,
      };
      return result;
    },
    getGateDestinations(source) {
      const destinations = this.orderDetails.destinations;
      const gateId = source.gate_id;
      return destinations
        .filter(_destiantion => gateId === _destiantion.source_gate_id)
        .map(consignee => this.constructDestination(consignee));
    },
    getSourceDestinations(source) {
      const destinations = this.orderDetails.destinations;
      const locationId = source.location_id;
      return destinations
        .filter(_destiantion => locationId === _destiantion.source_location_id)
        .map(consignee => this.constructDestination(consignee));
    },
    sourceHasGateRefrenceId(gateId, locationId, source) {
      return gateId && source.type === this.types.DEPOT
        ? this.$depot.otherGate(gateId, locationId).reference_id
        : source.details.reference_id;
    },
    sourceHasGate(gateId, locationId, source) {
      return gateId && source.type === this.types.DEPOT
        ? this.$depot.otherGate(gateId, locationId).name
        : source.details.name;
    },
    getSoldToRefIdWithCity(data) {
      return data && data.sold_to_ref_id && data.sold_to_city ? `${data.sold_to_ref_id} - ${data.sold_to_city}` : data.sold_to_ref_id;
    },
    getShippedToRefIdWithCity(data) {
      return data && data.ref_id && data.shipped_to_city ? `${data.ref_id} - ${data.shipped_to_city}` : data.ref_id;
    },
    closeDrawer() {
      console.log('in close drawer');
    },
    async getBaseFreightCharges() {
      let paymentFetchFailed = false;
      this.baseFreightCharge = 0;
      if (!this.$hasFeature('payments_v2')) {
        this.baseFreightCharge = await this.$store.dispatch(
          'order/getPaymentCharges',
          {
            orderId: this.orderDetails.id,
          },
        );
      } else {
        const response = await this.$store.dispatch(
          'paymentsV2/getIndentCharges',
          {
            orderNo: this.orderDetails.order_number,
          },
        );
        if (response) {
          if (response.status && response.status >= 400) {
            paymentFetchFailed = true;
          } else if (response.payCharges && response.payCharges.contract_charge) {
            this.baseFreightCharge = response.payCharges.contract_charge;
          } else if (response.walletCharges && response.walletCharges.contract_charge) {
            this.baseFreightCharge = response.walletCharges.contract_charge;
          }
        }
      }
      if (paymentFetchFailed && (!this.orderDetails.base_frieght || !this.orderDetails.base_frieght.freight_charge)) {
        this.baseFreightCharge = 'NA';
      } else {
        const chargeToBeConsidered =
          this.baseFreightCharge ||
          (this.orderDetails.base_frieght && this.orderDetails.base_frieght.freight_charge) ||
          0;
        this.baseFreightCharge = Number(chargeToBeConsidered).toFixed(2);
      }
    },
  },
};
</script>
  <style lang="scss">
  .track {
    iframe {
      height: 400px;
    }
  }
  .map-container {
    width: 100% !important;
  }
  </style>
